
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Monthlycarrentalcabserviceinnashik() {



const cardData = {
  keyword: 'Monthly Car Rental Cab Service in Nashik',
  heading: 'eTravo: Monthly Car Rental Cab Service in Nashik',
  headingDescription: `eTravo offers flexible and affordable monthly car rental cab services in Nashik, perfect for businesses, professionals, and long-term travelers seeking consistent and reliable transportation. Whether you need a vehicle for daily office commutes, staff transportation, or executive mobility, our well-maintained, air-conditioned, and GPS-enabled fleet is ready to serve your needs with utmost convenience. Our monthly rental plans are designed to be cost-effective, customizable, and hassle-free—ideal for companies managing employee movement or individuals requiring regular travel within or around Nashik. With professional drivers, 24/7 customer support, and transparent pricing, eTravo ensures a smooth and dependable monthly cab rental experience.`,

  top: 'Top Places to visit in Nashik with eTravo',
   "topPlaces": [
    {
      "title": "Satpur MIDC Industrial Area",
      "description": "Satpur MIDC is one of Nashik's prominent industrial zones, housing a diverse range of industries including engineering, automotive, and electrical sectors. eTravo offers tailored transportation solutions to ensure timely and efficient employee commutes, supporting shift operations and enhancing industrial productivity."
    },
    {
      "title": "Ambad MIDC Industrial Area",
      "description": "Ambad MIDC hosts numerous small, medium, and large industrial units, contributing significantly to Nashik's economic landscape. eTravo provides dependable cab services for employees and executives, facilitating smooth transportation to and from the industrial area."
    },
    {
      "title": "Sinnar Industrial Area",
      "description": "Located just 24 km from Nashik, Sinnar Industrial Area is a fully developed zone poised for significant growth. eTravo supports logistics personnel with scheduled and on-demand cab services, ensuring smooth operations and timely deliveries."
    },
    {
      "title": "Nashik City Center",
      "description": "The commercial and administrative heart of Nashik, featuring government offices, banks, and corporate establishments. eTravo's executive cab services facilitate seamless travel for business meetings and official engagements, ensuring punctuality and comfort."
    },
    {
      "title": "Nashik Road Railway Station",
      "description": "A crucial railway hub connecting Nashik with major cities across India. eTravo offers convenient pickup and drop services, bridging the gap between rail travel and workplace commutes for employees and business travelers."
    },
    {
      "title": "Yashwantrao Chavan Maharashtra Open University (YCMOU)",
      "description": "A premier educational institution attracting students and faculty from various regions. eTravo offers reliable transportation solutions for daily commutes, academic events, and inter-campus travel, promoting educational excellence."
    },
    {
      "title": "Government Medical College, Nashik",
      "description": "A key healthcare and educational institution in the region. eTravo provides dependable cab services for medical professionals, students, and patients, ensuring timely arrivals and departures for critical healthcare services."
    },
    {
      "title": "City Centre Mall, Nashik",
      "description": "A popular shopping destination in Nashik, offering a variety of retail outlets and entertainment options. eTravo facilitates transportation for shoppers and retail employees, enhancing the shopping experience with convenient and safe travel options."
    },
    {
      "title": "The Gateway Hotel Ambad, Nashik",
      "description": "A renowned hospitality establishment in Nashik. eTravo provides transportation solutions for hotel staff and guests, ensuring seamless travel experiences within the hospitality industry."
    },
    {
      "title": "K.K. Wagh Institute of Engineering Education and Research",
      "description": "An esteemed educational institution offering quality engineering education. eTravo provides transportation solutions for students and faculty members, ensuring safe and timely commutes."
    }
  ],

services: [
  {
    name: 'Nashik Monthly Car Rentals',
    description: `Monthly car rental packages designed to streamline corporate transportation needs across Nashik. Ideal for businesses seeking reliable long-term transport solutions, our monthly plans offer consistent vehicle availability, professional drivers, and easy billing cycles with flexible upgrade options.`
  },
  {
    name: 'Corporate Monthly Car Rental Nashik',
    description: `Tailored monthly car rental services for corporates requiring ongoing staff mobility. Our vehicles are maintained to high standards and come with dedicated drivers to support consistent, professional, and worry-free employee transport.`
  },
  {
    name: 'Employee Monthly Cab Service Nashik',
    description: `Reliable and cost-effective monthly cab services for daily employee commute needs. Designed around shift timings, these plans include GPS-enabled vehicles, round-the-clock support, and punctual operations across Nashik’s commercial and industrial zones.`
  },
  {
    name: 'Business Monthly Car Rentals Nashik',
    description: `Flexible monthly car rental plans for business executives and operational teams. Whether for client visits, field work, or inter-office travel, our service ensures a dependable fleet at your disposal with seamless monthly scheduling.`
  },
  {
    name: 'Corporate Staff Monthly Cab Nashik',
    description: `Optimized monthly cab services for corporate staff commuting in groups or individually. This plan reduces logistical overhead and costs while maintaining punctuality and safety with fixed routes and trained drivers.`
  },
  {
    name: 'Reliable Monthly Car Service Nashik',
    description: `Trustworthy monthly car rental service backed by consistent vehicle performance and trained chauffeurs. With fixed-rate packages, proactive maintenance, and customer support, this service provides uninterrupted mobility throughout the month.`
  },
  {
    name: 'AC Monthly Car Rentals Nashik',
    description: `Comfortable, air-conditioned monthly cab rentals that deliver a relaxed commute experience in Nashik’s varying weather. Our AC fleet includes sedans, hatchbacks, and executive cars—perfect for regular corporate and staff usage.`
  },
  {
    name: 'Staff Pickup and Drop Monthly Cab Nashik',
    description: `Scheduled monthly cab plans for staff pickup and drop-off, covering day and night shifts. Includes route planning, safety tracking, and flexibility for seasonal or operational changes, supporting uninterrupted business activity.`
  },
  {
    name: 'Affordable Monthly Corporate Car Rentals Nashik',
    description: `Budget-conscious monthly car rental plans for startups, SMEs, and large enterprises. Benefit from predictable costs, vehicle scalability, and quality service—ideal for businesses optimizing their transportation expenses.`
  },
  {
    name: 'Executive Monthly Cab Service Nashik',
    description: `Monthly executive cab services featuring luxury vehicles and experienced chauffeurs. Designed for senior management and visiting professionals, our service ensures comfortable and punctual travel across corporate appointments and airport transfers.`
  },
  {
    name: 'Monthly Employee Transport Nashik',
    description: `Dedicated monthly employee transport services with multiple route mapping and full-time availability. Especially suited for factory and IT park teams, this solution improves attendance and workforce satisfaction.`
  },
  {
    name: 'Corporate Client Monthly Car Rentals Nashik',
    description: `Professional-grade monthly car services for client movement, ensuring VIP-level experience during their stay or visit. Vehicles are clean, presentable, and driven by courteous professionals to uphold your brand’s image.`
  },
  {
    name: 'Business Meeting Monthly Car Rental Nashik',
    description: `Pre-booked monthly car services for business meetings and field visits. Minimize delays and maximize productivity with consistently available vehicles and prompt, dependable drivers familiar with Nashik’s routes.`
  },
  {
    name: 'Monthly Corporate Vehicle Hire Nashik',
    description: `Flexible vehicle hiring plans on a monthly basis for corporates needing cars for varied operational needs. Be it field logistics, guest transport, or administrative errands, we provide dependable service without long-term commitment.`
  },
  {
    name: 'Corporate Shuttle Monthly Car Service Nashik',
    description: `Monthly shuttle services using vans or minibuses to move staff in large groups, particularly during shift timings. A sustainable and organized solution that improves efficiency and reduces per-head transport costs for organizations.`
  }
],

tableData: [
  ['Nashik Monthly Car Rentals', 'Corporate Monthly Car Rental Nashik'],
  ['Employee Monthly Cab Service Nashik', 'Business Monthly Car Rentals Nashik'],
  ['Corporate Staff Monthly Cab Nashik', 'Reliable Monthly Car Service Nashik'],
  ['AC Monthly Car Rentals Nashik', 'Staff Pickup and Drop Monthly Cab Nashik'],
  ['Affordable Monthly Corporate Car Rentals Nashik', 'Executive Monthly Cab Service Nashik'],
  ['Monthly Employee Transport Nashik', 'Corporate Client Monthly Car Rentals Nashik'],
  ['Business Meeting Monthly Car Rental Nashik', 'Monthly Corporate Vehicle Hire Nashik'],
  ['Corporate Shuttle Monthly Car Service Nashik', '']
],


"whychoose": [
  {
    "WhyChooseheading": "Flexible Monthly Car Rental Cab Services in Nashik",
    "WhyChoosedescription": "eTravo offers affordable and reliable monthly car rental cab services for businesses and professionals in Nashik. Our long-term rental plans are perfect for companies needing consistent, cost-effective employee or executive transportation."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles to Meet Varied Business Needs",
    "WhyChoosedescription": "Choose from a range of well-maintained sedans, SUVs, and MUVs to suit your specific requirements. Whether it’s daily employee commutes or executive travel, we have the right vehicle for every purpose."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Safe and Efficient Travel",
    "WhyChoosedescription": "Our drivers are highly experienced and trained in both city and industrial routes across Nashik. Their professionalism and punctuality ensure a seamless travel experience throughout the month."
  },
  {
    "WhyChooseheading": "Customized Rental Packages for Monthly Use",
    "WhyChoosedescription": "We provide tailored monthly rental packages that align with your usage, shift patterns, and operational needs—helping you control transportation costs while maintaining service quality."
  },
  {
    "WhyChooseheading": "GPS-Enabled Cabs for Safety and Real-Time Tracking",
    "WhyChoosedescription": "All vehicles are equipped with GPS tracking for real-time monitoring, giving businesses complete visibility and control over employee transport activities."
  },
  {
    "WhyChooseheading": "Transparent Pricing with Detailed Monthly Invoices",
    "WhyChoosedescription": "Our monthly billing includes itemized invoices that provide full transparency into ride history, distances, and fare components—making it easy for corporate accounting."
  },
  {
    "WhyChooseheading": "Adherence to Safety and Hygiene Standards",
    "WhyChoosedescription": "All vehicles are sanitized regularly and maintained to ensure a clean, safe, and hygienic environment for passengers throughout the rental period."
  },
  {
    "WhyChooseheading": "Dedicated Support and Account Management",
    "WhyChoosedescription": "A dedicated account manager will oversee your monthly rental plan, assist with scheduling, and ensure your transport operations run smoothly without interruptions."
  }
]











}

const faqData = [
  [
    {
      question: "Which areas do your monthly car rental services in Nashik cover?",
      answer: "We offer monthly rental cab services across Nashik, including Ambad MIDC, Satpur MIDC, Sinnar, and other industrial and business zones."
    },
    {
      question: "Can we customize the rental plan based on our company’s requirements?",
      answer: "Yes, we provide flexible rental packages tailored to your business needs, including dedicated vehicles and drivers for daily use."
    },
    {
      question: "Do you offer corporate billing with GST-compliant invoices?",
      answer: "Absolutely. Our monthly car rental plans include consolidated billing with GST-compliant invoices and detailed usage reports."
    },
    {
      question: "Are drivers included in the monthly rental plan?",
      answer: "Yes, professional drivers are included. They are trained in safe driving, corporate etiquette, and are familiar with Nashik routes."
    },
    {
      question: "What safety protocols do you follow for rented vehicles?",
      answer: "All our vehicles undergo regular maintenance, are GPS-enabled, sanitized daily, and are operated by verified drivers."
    },
    {
      question: "Is dedicated support available for long-term corporate rentals?",
      answer: "Yes, we provide dedicated account managers and priority support to ensure smooth coordination and service delivery."
    }
  ]
];

const testimonialsData = [
  {
    name: "Mr. Rajendra Gite",
    designation: "Admin Head, Nashik Precision Tools Ltd.",
    rating: [1, 1, 1, 1, 1],
    text: "“eTravo’s monthly rental service is ideal for our long-term transport needs. Reliable cars, trained drivers, and great support!”"
  },
  {
    name: "Ms. Aarti Kulkarni",
    designation: "Operations Manager, Nashik Industrial Logistics",
    rating: [1, 1, 1, 1, 1],
    text: "“With eTravo’s monthly car rentals, we've reduced our transport management hassle significantly. Highly recommended for businesses.”"
  }
];












































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Monthly Car Rental Cab Service in Nashik",
  "image": "https://www.etravo.in/images/keyword/monthly-car-rental-nashik.jpg",
  "description": "Reliable monthly car rental cab service in Nashik offering corporate monthly rentals, employee transport, business travel, and affordable AC monthly corporate car rentals with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/monthly-car-rental-cab-service-nashik"
  }
};







    return (
        <div>

<Helmet>
  <title>Monthly Car Rental Cab Service in Nashik | Corporate Monthly Rentals | eTravo</title>
  <meta 
    name="description" 
    content="Book reliable monthly car rental cab service in Nashik for corporate staff, employee transport, and business meetings. Affordable AC corporate monthly car rentals at eTravo." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/94.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Monthlycarrentalcabserviceinnashik;